import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findRuleList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/findAll?` + params,
        method: 'GET'
    })
}

export const findRuleAll = () => {
    return request({
        url: `${baseUrl}/joins-sms/v1/rule`,
        method: 'GET'
    })
}

export const addRule = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/insertRule`,
        method: 'POST',
        data: data
    })
}
export const editRule = (data) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/updateRule`,
        method: 'PUT',
        data: data
    })
}
export const delRule = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/deleteRule/${temp}`,
        method: 'DELETE'
    })
}
export const startRule = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/startRule/${id}`,
        method: 'GET'
    })
}
export const stopRule = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/stopRule/${id}`,
        method: 'GET'
    })
}